import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo, useState } from 'react';
import { createSelector } from 'reselect';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { selectSelectedDeviceFields } from 'entities/device/lib';
import { SettingsMasterContext } from './type';
import { useSaveMasterSettings } from 'features/settings-master/api/save-config';
import { getHintTitle } from 'widgets/settings-master/lib/hint-title';
export const selectDeviceForSettingsMaster = createSelector(selectSelectedDeviceFields([
    'id',
    'hardware_type',
    'device_type',
]), (dev) => (dev != null ? dev : null));
const arrTypeDeviceForMasterSettings = {
    SMART: ['SMART', 'H1V'],
    Zota: ['SMART_ZOTA'],
};
export const SettingsMasterContextProvider = memo(function SettingsMasterContextProvider(props) {
    const { children } = props;
    const [progress, setProgress] = useState(10);
    const [path, setPath] = useState([]);
    const [hint_key, setHintKey] = useState(null);
    const [dataSelectSettings, setDataSelectSettings] = useState({});
    const device = useAppSelector(selectDeviceForSettingsMaster);
    const device_type = useMemo(() => {
        if (device == null ||
            device.device_type == null ||
            device.hardware_type == null) {
            return null;
        }
        return device.device_type.code;
    }, [device]);
    const typeDeviceForMasterSettings = useMemo(() => {
        if (device_type) {
            return (Object.keys(arrTypeDeviceForMasterSettings).find((key) => arrTypeDeviceForMasterSettings[key].includes(device_type)) ?? 'SMART');
        }
        else {
            return 'SMART';
        }
    }, []);
    const closeHintDialog = useCallback(() => setHintKey(null), [setHintKey]);
    const onSave = useSaveMasterSettings(device?.id, path, dataSelectSettings);
    const context = useMemo(() => ({
        device_type,
        typeDeviceForMasterSettings,
        progress,
        path,
        device_id: device?.id ?? -1,
        hint_key,
        closeHintDialog,
        onSave,
        dataSelectSettings,
        setDataSelectSettings,
        getHintTitle: getHintTitle(device_type),
        setProgress,
        setPath,
        setHintKey,
    }), [progress, path, device, hint_key, onSave, device_type]);
    return (_jsx(SettingsMasterContext.Provider, { value: context, children: children }));
});
